app.views.shared = app.views.base.extend({
  attr: {
    form: 'data-form',
    spinner: 'data-form-spinner',
    headerUtility: 'data-header-utility',
    passwordShowField: 'data-show-modal-password'
  },
  classes: {
    validationErrors: 'validation-summary-errors'
  },
  init: function init(container) {
    this.initFormSpinners(container);
    this.initShowModalPasswordEventListener(container);
  },
  initFormSpinners: function initFormSpinners(container) {
    var _this = this;
    $(container).find('[' + this.attr.form + ']').each(function () {
      var spinner = $(this).find('[' + _this.attr.spinner + ']');
      $(this).submit(function () {
        $(this).validate();
        if ($(this).valid()) {
          if (spinner) {
            spinner.show();
          }
        }
      });
    });
  },
  validateForm: function validateForm(form) {
    var errors = form.find('.' + this.classes.validationErrors);
    return errors.length < 1 ? true : false;
  },
  /**
   * On Show Password Event Listener
   * Fires when the user click to show the password in visible text.
   * @public
   */

  initShowModalPasswordEventListener: function initShowModalPasswordEventListener(container) {
    $(container).find('[' + this.attr.passwordShowField + ']').each(function () {
      $(this).off('click');
      $(this).on('click', function () {
        var input = $(this).parents('.input').find('input');
        if (input.attr('type') === 'password') {
          $(this).html('Hide');
          input.attr('type', 'text');
        } else {
          $(this).html('Show');
          input.attr('type', 'password');
        }
      });
    });
  }
});